import React, { useContext } from "react";
import { Smile } from "react-feather";
import { MenuContext } from "../Menu/MenuManager";
import classNames from "classnames";

import "./style.scss";
import ConfigData from '../../config.json';

const ContactButton = () => {
  const { setOpen, open } = useContext(MenuContext);

  return (
    <button
      className={classNames("contact-button", { open })}
      onClick={() => setOpen(!open)}
    >
      <span>{ConfigData.contact.phoneNumber}</span> <Smile />
    </button>
  );
};

export default ContactButton;